import { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import RecipeList from './components/RecipeList';
import Favorites from './components/Favorites';
import Settings from './components/Settings';
import CreateRecipe from './components/CreateRecipe';
import FlavorList from './components/FlavorList';
import { supabaseManager } from './utils/supabaseManager';
import './App.scss';

export default function App() {
  useEffect(() => {
    let authListenerSubscription: any = null;

    const initSupabase = async () => {
      if (supabaseManager.isConfigured) {
        const success = await supabaseManager.initialize();
        if (success) {
          const client = supabaseManager.getClient();
          if (client) {
            // Get initial session
            const { data: { session } } = await client.auth.getSession();
            await updateLocalAuth(session);

            // Listen to auth state changes
            const { data: { subscription } } = client.auth.onAuthStateChange(async (_event, session) => {
              await updateLocalAuth(session);
            });
            authListenerSubscription = subscription;
          }
        }
      }
    };

    const updateLocalAuth = async (session: any) => {
      const authKey = 'hf_auth_user';
      if (session) {
        const user = session.user;
        const metadata = user.user_metadata || {};

        let dbAvatarUrl = '';
        let dbUsername = '';
        try {
          const { data, error } = await supabaseManager.getProfile(user.id);
          if (data && !error) {
            dbAvatarUrl = data.avatar_url || '';
            dbUsername = data.username || '';
          }
        } catch (e) {
          console.error('Failed to fetch user profile from DB:', e);
        }

        const updatedUser = {
          username: dbUsername || metadata.username || user.email?.split('@')[0] || 'no name',
          email: user.email || '',
          avatarUrl: dbAvatarUrl || metadata.avatarUrl || '',
          isLoggedIn: true,
        };
        localStorage.setItem(authKey, JSON.stringify(updatedUser));
        window.dispatchEvent(new Event('hf-auth-change'));
      } else {
        // If not logged in, reset local status if they were logged in with Supabase
        const localData = localStorage.getItem(authKey);
        if (localData) {
          try {
            const user = JSON.parse(localData);
            if (user.isLoggedIn) {
              const resetUser = {
                username: 'no name',
                email: 'user@example.com',
                avatarUrl: '',
                isLoggedIn: false,
              };
              localStorage.setItem(authKey, JSON.stringify(resetUser));
              window.dispatchEvent(new Event('hf-auth-change'));
            }
          } catch (e) {}
        }
      }
    };

    initSupabase();

    return () => {
      if (authListenerSubscription) {
        authListenerSubscription.unsubscribe();
      }
    };
  }, []);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/recipes" element={<RecipeList />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/create-recipe" element={<CreateRecipe />} />
          <Route path="/flavors" element={<FlavorList />} />
        </Routes>
      </Layout>
    </Router>
  );
}
